<template>
  <div class="CompareLibrariesComponent">
      <p>{{lang.infotext_1}}:</p>
        <b-button v-on:click="analyze" size="sm" class="btn btn-secondary" :variant="variant" :disabled="selectedRevisionRow.length!=2">{{lang.button_Analyze}}</b-button>
        <br>  
        <br>
       
        <span v-show="isRaport">
        <div id="img_diff" class="img_diff"></div>
        <br>
        <p>Report:</p>
        <table id="areport"></table>
        </span>
    

    <br>
 </div>
</template>

<script>

import svg from 'svg.js'
import resemble from "resemblejs/resemble"

//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

export default {
  name: 'CompareComponent',
  props:{
    lang: Object
  },
  data () {
    return {
      
      layerProperties: [],
      svgdraw: "",
      svgdraw_img: "",
      svgdraw_rect: "",
      scale: "",
      diffBoundsArray: [],
      resembleControl: "",
      indexLayers: 0,
      isRaport: false
    }
  },
  computed:{
    variant(){
    if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
    }else{
        return "dark";
    }
    
    },
    selectedRevisionRow(){
        return this.$store.getters.selectedRevisionRow;
    },  
    // isLoaded1(){
    //   console.log("isLoaded1")
    //   var q1 = document.getElementById("imageDetails__"+this.selectedRevisionRow[0].revisionId);

    //   if (q1 != null){
    //     return true
    //   }else{
    //     return false
    //   }


    // },
    // isLoaded2(){
    //   console.log("isLoaded2")
    //   var q2 = document.getElementById("imageDetails__"+this.selectedRevisionRow[1].revisionId);

    //   if (q2 != null){
    //     return true
    //   }else{
    //     return false
    //   }


    // }

  },

  created () {
    
  },
  updated() {
    
  },
  mounted: function () {
    // console.log("mounted compare")

    // var _this = this
    // this.$nextTick(function () {


    //   setTimeout(function () {

    //     _this.analyze();

    //   },1000)
    // })
  },
  watch: {
    // isLoaded1: function (new_isLoaded1, old_isLoaded1) {
    //   console.log("watch isLoaded1")



    // },
    // isLoaded2: function (new_isLoaded2, old_isLoaded2) {
    //   console.log("watch isLoaded2")



    // }
  },
  methods: {
    analyze: function (index) {
      console.log("ANALYZE!!!!!")
        this.isRaport = true;


      var layersArray = [];
      var layersDifferentArray = [];
      var _vue = this

      var svgcheck = document.getElementById("svgImage");
      if (svgcheck == undefined) {
          this.svgdraw = SVG('img_diff').attr('id', "svgImage");
          this.svgdraw_img = this.svgdraw.group();
          this.svgdraw_rect = this.svgdraw.group();
      } else {
          this.svgdraw_img.clear();
          this.svgdraw_rect.clear();
      }



      var q1 = document.getElementById("imageDetails__"+this.selectedRevisionRow[0].revisionId);
      var q2 = document.getElementById("imageDetails__"+this.selectedRevisionRow[1].revisionId);
      console.log(q1)
      console.log(q2)
      console.log(q1.firstChild)
      console.log(q2.firstChild)
      //var qq1 = q1.contentDocument.firstChild.nextSibling;
      //var qq2 = q2.contentDocument.firstChild.nextSibling;
      var qq1 = q1.firstChild//.nextSibling;
      var qq2 = q2.firstChild//.nextSibling;

      var img1 = this.convertToBase64(qq1);
      var img2 = this.convertToBase64(qq2);

      var dx = qq1.getAttribute("width");
      var dy = qq1.getAttribute("height");
      this.scale = dx / 400;


      var len = qq1.childNodes.length;
      for (var i = 0; i < len; i++) {

          if (qq1.childNodes[i].nodeName != "#text") {

              if ((qq1.childNodes[i].className.baseVal != "") && (qq1.childNodes[i].className.baseVal != undefined)) {


                  layersArray.push(qq1.childNodes[i].className.baseVal)
              }
          }


      }

      len = qq2.childNodes.length;
      for (var i = 0; i < len; i++) {

          if (qq2.childNodes[i].nodeName != "#text") {
              if ((qq2.childNodes[i].className.baseVal != "")&& (qq2.childNodes[i].className.baseVal != undefined)) {
                  //console.log(qq2.childNodes[i])

                  layersArray.push(qq2.childNodes[i].className.baseVal);
              }
          }


      }

      layersArray = this.removeDuplicates(layersArray)

      this.resetLayers(layersArray)

      var _svgdraw = this.svgdraw;
      var _scale = this.scale;
      var _svgdraw_img = this.svgdraw_img;
      this.resembleControl = resemble(img1).compareTo(img2).ignoreColors().onComplete(function (data) {


          _svgdraw.size(400, dy / _scale);


          _svgdraw_img.clear();
          var image = _svgdraw_img.image(data.getImageDataUrl(), 400, dy / _scale)


          _vue.getDifferent(layersArray);
      });
    },
    createReport: function (ar) {

        var _vue = this
        //createReportAnalysis();

        var table = document.getElementById("areport");
        while (table.hasChildNodes()) {
            table.removeChild(table.firstChild);
        }
        var checkArray = [];
        table.setAttribute("class", "reportTable");

        var header = ["check", "Layer", "Mismatch", "Show differences"];
        var tr = document.createElement("tr");
        var l = header.length;
        for (var j = 0; j < l; j++) {
            var th = document.createElement("th");
             th.setAttribute("class", "thclass");

            if (header[j] == "check") {
                var t = document.createElement("input");
                t.setAttribute("type", "checkbox");
                t.setAttribute("id", "allcheck");
                t.setAttribute("checked", "checked");

                t.addEventListener("change", function (evt) {




                    for (var i = 0; i < checkArray.length; i++) {
                        checkArray[i].checked = evt.target.checked;
                    }

                    _vue.checkAnalyze("all", evt.target.checked, ar);
                })
            } else {
                var t = document.createTextNode(header[j]);
            }

            th.appendChild(t);
            tr.appendChild(th);
        }

        table.appendChild(tr);


        var le = ar.length;

        for (var i = 0; i < le; i++) {

            //tr###
            var tr = document.createElement("tr");
            //td____
            var td = document.createElement("td");

            var check = document.createElement("input");
            check.setAttribute("type", "checkbox");
            check.setAttribute("id", "check" + ar[i]);
            check.setAttribute("name", ar[i]);
            check.setAttribute("checked", "checked");
            td.appendChild(check);



            check.addEventListener("change", function (evt) {

                _vue.checkAnalyze(evt.target.name, evt.target.checked, ar);
            })
            checkArray.push(check);
            //td____
            tr.appendChild(td);
            //td____
            td = document.createElement("td");
            var name = document.createTextNode(ar[i]);
            td.appendChild(name);

            tr.appendChild(td);

            var value = this.layerProperties[i];

            td = document.createElement("td");
            if (value == 0) {
                td.setAttribute("class", "ComboBoxGreeen");
            } else {
                td.setAttribute("class", "ComboBoxRed");
            }

            var proc = document.createTextNode(value + "%");
            td.appendChild(proc);


            tr.appendChild(td);
            //td____
            td = document.createElement("td");
            var checkFrame = document.createElement("input");
            checkFrame.setAttribute("type", "checkbox");
            checkFrame.setAttribute("id", "checkFrame" + ar[i]);
            checkFrame.setAttribute("name", ar[i]);
            if (value == 0) {
                checkFrame.setAttribute("disabled", "disabled")
            }
            //checkFrame.setAttribute("checked", "checked");
            td.appendChild(checkFrame);

            checkFrame.addEventListener("change", function (evt) {

                _vue.turnFrame(evt.target.name, evt.target.checked, ar)
            })

            checkArray.push(check);
            //td____
            tr.appendChild(td);
            //tr###
            table.appendChild(tr);

        }



        //<col width="30*"><col width="30*"><col width="30*"><tr id="areport"></tr>
    },
    turnFrame: function (layer, status, layers, bbox) {

        var index = 0;

        var le = layers.length;
        for (var i = 0; i < le; i++) {
            if (layer == layers[i]) {
                index = i;
                break;
            }
        }



        var dxImg = this.svgdraw.attr("width");
        var dyImg = this.svgdraw.attr("height");



        var x1 = (this.diffBoundsArray[index].left - 10)/this.scale;
        var y1 = (this.diffBoundsArray[index].top - 10)/this.scale;
        var x2 = this.diffBoundsArray[index].right/this.scale;
        var y2 = this.diffBoundsArray[index].bottom / this.scale;

        var w = (this.diffBoundsArray[index].right - this.diffBoundsArray[index].left + 20)/this.scale;
        var h = (this.diffBoundsArray[index].bottom - this.diffBoundsArray[index].top + 20)/this.scale;



        if (status == true) {

            this.svgdraw_rect.rect(w, h).move(x1, y1).stroke({width: 5, color:"#3366cc"}).fill("none").attr("id", layer);
        } else {
            var element = SVG.get(layer).remove();


        }





    },
    setLayerVisibility: function (layers, index) {




        var small1 = document.getElementById("imageDetails__"+this.selectedRevisionRow[0].revisionId);
        var small2 = document.getElementById("imageDetails__"+this.selectedRevisionRow[1].revisionId);


        var svgDoc1 = small1.firstChild//contentDocument;
        var svgDoc2 = small2.firstChild//contentDocument;


        var le = layers.length;
        for (var i = 0; i < le; i++) {
            var layer = layers[i];

            if (i == this.indexLayers) {
                if (svgDoc1.getElementsByClassName(layer)[0] != undefined) {
                    svgDoc1.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                }
                if (svgDoc2.getElementsByClassName(layer)[0] != undefined) {
                    svgDoc2.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                }

            } else {
                if (svgDoc1.getElementsByClassName(layer)[0] != undefined) {
                    svgDoc1.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                }
                if (svgDoc2.getElementsByClassName(layer)[0] != undefined) {
                    svgDoc2.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                }


            }


        }






    },
    checkAnalyze: function (who, status, layers) {


        var _vue = this;
        console.log("checkAnalyze")
        if (who == "all") {
            this.resetLayers(layers);
        }


        //set layers
        this.setLayerVisibilityCheck(who, status, layers);
        //analyze

        var q1 = document.getElementById("imageDetails__"+this.selectedRevisionRow[0].revisionId);
        var q2 = document.getElementById("imageDetails__"+this.selectedRevisionRow[1].revisionId);

        var qq1 = q1.firstChild//contentDocument.firstChild.nextSibling;
        var qq2 = q2.firstChild//contentDocument.firstChild.nextSibling;


        var dx = qq1.getAttribute("width");
        var dy = qq1.getAttribute("height");
        var scale = dx / 400;


        var img1 = this.convertToBase64(qq1);
        var img2 = this.convertToBase64(qq2);

        this.resembleControl = resemble(img1).compareTo(img2).ignoreColors().onComplete(function (data) {


            _vue.svgdraw_img.clear();

            var image = _vue.svgdraw_img.image(data.getImageDataUrl(), 400, dy / scale)

        });

    },
    setLayerVisibilityCheck: function (layer, status, layers) {



        var small1 = document.getElementById("imageDetails__"+this.selectedRevisionRow[0].revisionId);
        var small2 = document.getElementById("imageDetails__"+this.selectedRevisionRow[1].revisionId);


        var svgDoc1 = small1.firstChild//contentDocument;
        var svgDoc2 = small2.firstChild//contentDocument;


        if (layer == "all") {
            var le = layers.length;
            for (var i = 0; i < le; i++) {
                layer = layers[i];

                if (status == true) {
                    if (svgDoc1.getElementsByClassName(layer)[0] != undefined) {
                        svgDoc1.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                    }
                    if (svgDoc2.getElementsByClassName(layer)[0] != undefined) {
                        svgDoc2.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                    }
                } else {
                    if (svgDoc1.getElementsByClassName(layer)[0] != undefined) {
                        svgDoc1.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                    }
                    if (svgDoc2.getElementsByClassName(layer)[0] != undefined) {
                        svgDoc2.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                    }
                }
            }

        } else {
            if (svgDoc1.getElementsByClassName(layer)[0] != undefined) {
                if (status == true) {
                    svgDoc1.getElementsByClassName(layer)[0].style["visibility"] = "visible";

                } else {
                    svgDoc1.getElementsByClassName(layer)[0].style["visibility"] = "hidden";

                }


            }
            if (svgDoc2.getElementsByClassName(layer)[0] != undefined) {
                if (status == true) {

                    svgDoc2.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                } else {

                    svgDoc2.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                }


            }

        }



    },
    getDifferent: function (layers) {


        console.log("getDifferent")

        this.setLayerVisibility(layers, this.indexLayers);


        var _vue = this


            var q1 = document.getElementById("imageDetails__"+this.selectedRevisionRow[0].revisionId);
            var q2 = document.getElementById("imageDetails__"+this.selectedRevisionRow[1].revisionId);

            var qq1 = q1.firstChild//contentDocument.firstChild.nextSibling;
            var qq2 = q2.firstChild//contentDocument.firstChild.nextSibling;



            var img1 = _vue.convertToBase64(qq1);
            var img2 = _vue.convertToBase64(qq2);



            this.resembleControl = resemble(img1).compareTo(img2).ignoreColors().onComplete(function (data) {

                _vue.diffBoundsArray[_vue.indexLayers] = data.diffBounds;

                _vue.layerProperties[_vue.indexLayers] = data.misMatchPercentage;
                var len = layers.length;
                var l = len - 1

                if (_vue.indexLayers == len - 1) {

                    _vue.indexLayers = 0;
                    _vue.resetLayers(layers);
                    _vue.createReport(layers);

                } else {

                    _vue.indexLayers++;

                    _vue.getDifferent(layers);

                }


                //console.log(layerProperties)


            });
      //  }, 0); // for 3 seconds




        //return index;
    },
    resetLayers: function (layers) {

        console.log("resetLayers")


        var small1 = document.getElementById("imageDetails__"+this.selectedRevisionRow[0].revisionId);
        var small2 = document.getElementById("imageDetails__"+this.selectedRevisionRow[1].revisionId);


        var svgDoc1 = small1.firstChild//contentDocument;
        var svgDoc2 = small2.firstChild//contentDocument;

        var le = layers.length;
        for (var i = 0; i < le; i++) {

                if (svgDoc1.getElementsByClassName(layers[i])[0] != undefined) {
                    svgDoc1.getElementsByClassName(layers[i])[0].style["visibility"] = "visible";
                }
                if (svgDoc2.getElementsByClassName(layers[i])[0] != undefined) {
                    svgDoc2.getElementsByClassName(layers[i])[0].style["visibility"] = "visible";
                }


        }


    },
    /*
    createLayers: function (_class, data) {


        //<input type="checkbox" name="insurance" id="insurance">
        var but = document.createElement("button");
        but.setAttribute("id", _class + "button");
        but.setAttribute("type", "checkbox");
        but.setAttribute("name", _class);

        var report = document.getElementById("report");
        report.appendChild(but)


        //console.log(data.misMatchPercentage);

        if (data.misMatchPercentage == 0) {
            obj.match = true;
        } else {
            obj.match = false;
        }

    },*/
    removeDuplicates: function (elements) {


        return elements.filter(function (el, index, arr) {
            return arr.indexOf(el) === index;
        })
    },
    convertToBase64: function (svg) {

        console.log(svg)
        var xml = new XMLSerializer().serializeToString(svg);
        var data = "data:image/svg+xml;base64," + btoa(xml);

        return data;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  td {
      border: 1px solid #dee2e6 !important;
      padding: 10px !important;
      color: #ff2200
  }
  th {
    padding: 10px !important;
    background-color: #f3f3f3;
    border: 1px solid #dee2e6 !important;
  }
  .ComboBoxRed{
    background-color: #ff2200 !important;
    color: #fff;
  }
  .ComboBoxGreen {
      background-color: #247f3e;
  }
  .reportTable {
    text-align: center;

    border: 1px solid #dee2e6 !important;
    width: 100%;

  }
  .img_diff{
    
    background-color: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    margin-bottom: 3px;
    margin-top: 3px;
    overflow: hidden;
    width: 400px;
    height: 400px;
    
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/CompareLibrariesComponent.vue